import { jsx as o } from "react/jsx-runtime";
import r from "./chunk568.js";
const m = (l) => {
  const { show: e, color1: a, color2: c, color3: d, color4: s, zIndex: i } = l;
  return /* @__PURE__ */ o(
    "div",
    {
      className: r.overlay,
      style: {
        zIndex: i,
        display: e ? "block" : "none",
        "--loader-color1": a,
        "--loader-color2": c,
        "--loader-color3": d,
        "--loader-color4": s
      },
      children: /* @__PURE__ */ o("div", { className: r.overlayLoader, children: /* @__PURE__ */ o("div", { className: r.loader }) })
    }
  );
};
export {
  m as Loader
};
